module.exports = __webpack_public_path__ + "img/galaxy_green.dd3233b0.png";